import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconCaretLeft = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M14.453 5.293a1 1 0 0 1 0 1.414L9.16 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-5.293-5.293a2 2 0 0 1 0-2.828l5.293-5.293a1 1 0 0 1 1.414 0", clipRule: "evenodd" }) });
const ForwardRef = forwardRef(SvgIconCaretLeft);
export default ForwardRef;
